import { sortTableEnum } from 'enum/sortTable.enum'

export const prepareSort = (
  sort: any,
  origen: string | undefined = undefined
) => {
  if (sort) {
    // @ts-ignore
    if (sort.field === 'full_name' && sort.order)
      return [
        // @ts-ignore
        `name ${sortTableEnum[sort.order]}`,
        // @ts-ignore
        `lastname ${sortTableEnum[sort.order]}`,
      ]
    // @ts-ignore
    if (sort && sort.order) return `${sort.field} ${sortTableEnum[sort.order]}`
  }
  if (origen === 'courses') return ['created_at desc']
  return [`name asc`, `lastname asc`]
}
